// src/lib/edgeFns.ts
import { supabase } from "../lib/supabase"; // ודא שזה הנתיב הנכון אצלך

export function normalizeIL(p: string) {
  const t = String(p || "").trim();
  // Remove all non-digit characters first (including +, -, spaces)
  let cleaned = t.replace(/[^\d]/g, "");

  // Handle different formats
  if (cleaned.startsWith("972")) {
    // Already starts with 972, remove leading 0 if present after 972
    if (cleaned.length === 12 && cleaned.charAt(3) === "0") {
      cleaned = "972" + cleaned.substring(4);
    }
    return "+" + cleaned;
  } else if (cleaned.startsWith("0")) {
    // Starts with 0, replace with 972
    return "+972" + cleaned.substring(1);
  } else if (/^[1-9]/.test(cleaned) && cleaned.length === 9) {
    // 9 digits without prefix
    return "+972" + cleaned;
  }

  return cleaned;
}

type FnOk = { success?: boolean } & Record<string, any>;

export async function sendOtp(phone: string) {
  const p = normalizeIL(phone);
  const { data, error } = await supabase.functions.invoke<FnOk>("send_otp", {
    body: { phone: p },
  });
  if (error) throw new Error(error.message || "send_otp failed");
  if (!data?.success) throw data;
  return data as { success: true; phone: string; ttl_seconds: number };
}

export async function verifyOtp(phone: string, code: string) {
  const p = normalizeIL(phone);
  const { data, error } = await supabase.functions.invoke<FnOk>("verify_otp", {
    body: { phone: p, code },
  });
  if (error) throw new Error(error.message || "verify_otp failed");
  if (!data?.success) throw data;
  return data as { success: true; phone: string };
}
